import Vue from 'vue';
import Router from 'vue-router';
import TokenService from '../services/token.service';
import i18n from "../i18n";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/login',
      name: 'login',
      component: () => import('@/views/auth/Login.vue'),
      meta: {
        onlyWhenLoggedOut: true,
        title: 'Login',
      },
    },
    {
      path: '/',
      component: () => import('@/layouts/DefaultLayout.vue'),
      children: [{
          path: '/dashboard',
          name: 'dashboard.index',
          component: () => import('@/views/dashboard/Dashboard'),
          meta: {
            title: 'Dashboard'
          }
        },
        {
          path: '/nouveau-comptage/:invoiceId?/:task?',
          name: 'search.index',
          component: () => import('@/views/search/Search'),
          meta: {
            title: 'NOUVEAU COMPTAGE'
          }
        },

        // HTML
        // ComptagesSauvegardes
        {
          name: 'comptages.sauvegardes',
          path: '/comptages-sauvegardes',
          component: () => import('@/views/dashboard/ComptagesSauvegardes'),
          meta: {
            title: 'Comptages Sauvegardes'
          }
        },
        // Devis
        // {
        //   name: 'Devis',
        //   path: '/devis',
        //   component: () => import('@/views/dashboard/Devis'),
        //   meta: {
        //     title: 'Devis'
        //   }
        // },
        // Campagnes
        // {
        //   name: 'Campagnes',
        //   path: '/campagnes',
        //   component: () => import('@/views/dashboard/Campagnes'),
        //   meta: {
        //     title: 'Campagnes'
        //   }
        // },
        // Statistiques
        {
          name: 'Statistiques',
          path: '/statistiques',
          component: () => import('@/views/dashboard/StatisticStudent'),
          meta: {
            title: 'Statistiques'
          }
        },
        // Clients
        {
          name: 'Clients',
          path: '/clients',
          component: () => import('@/views/dashboard/Clients'),
          meta: {
            title: 'Clients'
          }
        },
        // Databases
        {
          name: 'Databases',
          path: '/databases',
          component: () => import('@/views/dashboard/Databases'),
          meta: {
            title: i18n.t('Databases')
          }
        },
        // Unregister
        {
          name: 'Unregister',
          path: '/non-enregistrer',
          component: () => import('@/views/dashboard/Unregister'),
          meta: {
            title: `${i18n.t('Databases')} / ${i18n.t('Non-enregistrer')}`
          }
        },
        // User
        {
          name: 'Paramètres',
          path: '/parametre',
          component: () => import('@/views/dashboard/UserProfile'),
          meta: {
            title: 'Paramètres'
          }
        },
        {
          name: 'Test',
          path: '/test',
          component: () => import('@/views/Test'),
        },
        // Notification
        {
          name: 'Notification',
          path: '/notifications',
          component: () => import('@/views/dashboard/Notifications'),
          meta: {
            title: 'Notification'
          }
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const loggedIn = !!TokenService.getToken();
  const onlyWhenLoggedOut = to.matched.some(
    record => record.meta.onlyWhenLoggedOut,
  );

  if (loggedIn && onlyWhenLoggedOut) {
    return next({
      name: 'dashboard',
    });
  }

  if (!loggedIn && !onlyWhenLoggedOut) {
    return next({
      name: 'login',
      query: {
        redirect: to.fullPath
      },
    });
  }

  document.title = `${process.env.VUE_APP_NAME} - ${to.meta.title}`;

  next();
});

export default router;
